<template >
  <div >
    <!-- <p>{{ isMobileMode }}</p> -->
    <el-popover
        v-if="isMobileMode"
        placement="bottom"
        width="90%"
        trigger="manual"
        v-model="visiblePopover" >
      <el-row
          :gutter="10"
          @click.native="visiblePopover = false"
          class="float-items" >
        <slot ></slot >
      </el-row >
      <el-button
          slot="reference"
          plain
          type="dark"
          @click="visiblePopover = !visiblePopover" >
        <fa
            v-if="toastIcon"
            :icon="toastIcon"
            fixed-width
            size="lg" ></fa >
        <i
            v-else
            class="fas fa-align-justify" ></i >
        <span
            v-if="caption"
            v-html="caption" ></span >
      </el-button >
    </el-popover >
    <div
        v-else
        class="responsive-items" >
      <slot ></slot >
    </div >
  </div >
</template >

<script >
export default {
  name: "SResponsivePanel",
  props: [
    "right",
    "left",
    "caption",
    "heightResponsive",
    "goResponsive",
    "toastIcon",
    "floatToast",
  ],
  data() {
    return {
      isMobileMode: false,
      visiblePopover: false,
    }; //old val in watcher doesnot work??
  },
  computed: {
    filterStyle() {
      if (this.floatToast) {
        var stl = {
          width: "35px",
          height: "35px",
          backgroundColor: "#73daa8bf",
          color: "white",
          zIndex: 2,
          position: "fixed",
          // right: '-10px',
          borderRadius: "50%",
          boxShadow: "4px 3px 7px grey",
          marginTop: "-15px",
          paddingLeft: "3px",
          paddingTop: "5px",
        };
        if (this.right != undefined)
          stl.right =
              this.right && this.right != "" ? this.right + "px" : "15px";
        if (this.openContainer) stl.marginTop = "-30px";

        return stl;
      }
      return null;
    },
    containerStyle() {
      if (!this.isMobileMode)
        return {
          height: "auto",
          width: "100%",
        };
      else {
        if (this.openContainer)
          return {
            height: "auto",
            width: "100%",
          };
        else
          return {
            height: "0px",
            width: "100%",
          };
      }
    },
  },
  watch: {
    // goResponsive(val) {
    //   if (val != undefined) this.isMobileMode = val;
    // }
  },
  methods: {
    reposiveness() {
      this.isMobileMode = window.innerWidth < this.goResponsive;
    },
  },
  mounted() {
    const vm = this;
    vm.isMobileMode = window.innerWidth < vm.goResponsive;
    window.addEventListener("resize", vm.reposiveness);
    // window.onresize =
  },
};
</script >

<style >
.responsive-items {
  display: flex;
  flex-grow: 1;
}

.float-items .el-button {
  margin: 5px !important;
  padding: 10px;
}

.responsive-wrapper {
  display: flex;
  flex-grow: 1;
}
</style >
